import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  scheduleDueDateWarning:
    'The Due Date for this Invoice is in the past, if you update this date it must be today or a future date. These changes cannot be undone.',
  scheduleFormTitle: 'Schedule',
})
